//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

(function () {
  if (
    typeof WeixinJSBridge == "object" &&
    typeof WeixinJSBridge.invoke == "function"
  ) {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    }
  }
  function handleFontSize () {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on("menu:setfont", function () {
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    });
  }
})();
import mixUmeng from './assets/js/mixUmeng'
import {selectCdnConf} from './assets/js/api.js'
export default {
  provide(){
    return {
      reload:this.reload
    }
  },
  mixins: [mixUmeng],
  name: "App",
  data () {
    return {
      isRouterActive:true,
      // isshowvideobox:false,
      ua: navigator.userAgent.toLowerCase(), //浏览器标识
      docmHeight: "0", //默认屏幕高度
      showHeight: "0", //实时屏幕高度
      isResize: false ,//默认屏幕高度是否已获取
      isActive:false,
    };
  },
  // watch: {
  //   $route :{
  //     handler: function (newVal, oldVal) {
  //     if (oldVal.path === '/login' && newVal.path === '/personalIndex') {
  //       var videoshowdate = new Date().getMonth()+1+"-"+new Date().getDate();
  //       console.log(videoshowdate);
  //       if(window.localStorage.getItem("token") && JSON.parse(window.localStorage.getItem("user")).unitProvince == 19 ){
  //         if(window.localStorage.getItem("openday")!=videoshowdate){
  //           this.videoboxshow();
  //           window.localStorage.setItem("openday",videoshowdate)
  //         }
  //       }
  //     }
  //   }}
  // },
  created(){
    if(!window.sessionStorage.getItem("cdnConf")){
      selectCdnConf().then(res=>{
        if(res.message.errcode == 200) {
          this.$store.state.cdnConf = res.data
          window.sessionStorage.setItem("cdnConf",JSON.stringify(res.data))
        }
      })
    } else {
      this.$store.state.cdnConf = JSON.parse(window.sessionStorage.getItem("cdnConf"))
    }
  },
  mounted () {
    var videoshowdate = new Date().getMonth()+1+"-"+new Date().getDate();
    console.log(videoshowdate);
    this.$store.dispatch("GETYEARS");
    // if(window.localStorage.getItem("token") && JSON.parse(window.localStorage.getItem("user")).unitProvince == 19 ){
    //   if(window.localStorage.getItem("openday")!=videoshowdate){
    //     this.videoboxshow();
    //     window.localStorage.setItem("openday",videoshowdate)
    //   }
    // }
    if (/micromessenger/.test(this.ua)) {
      this.$store.state.isWx = true;
    }
    if (/android/.test(this.ua)) {
      this.$store.state.isAndroid = true;
    }
    if (/iphone|ipad|ipod/.test(this.ua)) {
      this.$store.state.isIos = true;
    }
    // window.onresize = () => {
    //     if (!this.isResize) {
    //         // 默认屏幕高度
    //         this.docmHeight = document.documentElement.clientHeight;
    //         this.isResize = true;
    //     }
    //     // 实时屏幕高度
    //     this.showHeight = document.body.clientHeight;
    //     if (this.docmHeight < this.showHeight) {
    //         this.$store.state.hidshow = true;
    //     } else if (this.$store.state.isAndroid) {
    //         this.$store.state.hidshow = false;
    //     }
    // };
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
      handleScroll(e) {
      //滚动条滚动 固定培训 活动 详情审核添加页面的头部（方便点击保存等操作）
      if (e.target.className&&e.target.className.indexOf("con") > -1) {
        let scrollTop = e.target.scrollTop;
        if (scrollTop >= 190) {
          this.isActive = true;
        }
      }
    },
    reload(){
      this.isRouterActive = false;
      this.$nextTick(()=>{
        this.isRouterActive = true;
      })
    },
    // videoboxshow(){
    //   this.isshowvideobox = true;
    //   document.querySelector("#zcvideo").play()
    // },
    // closeVideoBox(){
    //   this.isshowvideobox = false;
    //   document.querySelector("#zcvideo").pause();
    //   document.querySelector("#zcvideo").currentTime = 0
    // },
    handleClose(){
      this.$store.state.changePwdDialog=false;
    },
    cancelhandel(){
       this.$store.state.changePwdDialog=false;
    },
    edithandel(){
      this.$router.push({
          path: "/enitPassWord"
        });
      this.$store.state.changePwdDialog=false;
    },
   
    // //所有获取焦点事件
    // focusinFn() {
    //     //安卓虚拟键盘影响屏幕可视高度，ios没有
    //     if (this.$store.state.isAndroid) {
    //         this.$store.state.hidshow = false;
    //     }
    // },
    // // 所有失去焦点事件
    // focusoutFn() {
    //     this.$store.state.hidshow = true;
    // }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue